import { JiraIntegration } from './JiraIntegration';
import React from 'react';
import { ViewArea } from '@ui/general';
export const Jira = () => React.createElement(ViewArea, { direction: 'vertical', fullHeight: true, fullWidth: true, id: 'jira' },
    React.createElement(JiraIntegration, null));
